var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elmUpload"},[_c('input',{ref:"myFile",attrs:{"type":"file","accept":_vm.accept,"disabled":_vm.disabled,"single":""},on:{"change":_vm.change}})])}
var staticRenderFns = []

export { render, staticRenderFns }